import React, { useMemo } from 'react';
import theme from '@/constants/theme';
import { RangeQuestion } from '@/components/interactive/Quiz/common';

interface Props {
  value: string;
  options: RangeQuestion['options'];
  onChangeResponse?: (response: string) => void;
}

const RangeSelector: React.FC<Props> = ({ value, options, onChangeResponse }) => {
  const min = Number(options.min);
  const max = Number(options.max);
  const step = Number(options.step);

  const handleChange = (newValue: string) => {
    onChangeResponse?.(newValue);
  };

  const range = useMemo(
    () => Array.from({ length: max - min + 1 }, (_, i) => min + i * step),
    [max, min, step],
  );

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 32,
        placeItems: 'center',
        justifyContent: 'center',
        flex: 1,
        alignContent: 'center',
      }}
    >
      {/* <input
        className="range_question"
        type="range"
        min={options.min}
        max={options.max}
        step={options.step}
        value={value ?? ''}
        onChange={handleChange}
      /> */}
      {range.map((rangeValue, index) => (
        <label
          key={index}
          style={{
            width: '100%',
            maxWidth: 90,
            aspectRatio: 1,
            backgroundColor:
              rangeValue === Number(value) ? theme.colors.text.body : theme.colors.background.primary,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 10000,
            cursor: 'pointer',
            border: `1px solid ${theme.colors.border}`,
          }}
        >
          <input
            type="radio"
            checked={rangeValue === Number(value)}
            hidden
            onChange={() => handleChange(rangeValue.toString())}
          />
          <span
            style={{
              color: rangeValue === Number(value) ? theme.colors.text.contrast : theme.colors.text.caption,
              fontWeight: 'bold',
              fontSize: 24,
            }}
          >
            {rangeValue}
          </span>
        </label>
      ))}
    </div>
  );
};

export default RangeSelector;
